import React from "react";
import { Box, Grid, Paper, Typography } from "@mui/material";
const ToDate = (input) => {
  if (input) {
    let date = new Date(input);
    let output = date.toLocaleDateString();
    //handle default date from API
    if (date.getYear() === 1) return "";
    return output;
  } else {
    return "";
  }
};
const Cell = ({ label, value }) => (
  <Box>
    <Typography
      variant="caption"
      sx={{ display: "block", fontWeight: 600, color: "text.secondary" }}
    >
      {label}
    </Typography>
    <Typography variant="body2">{value}</Typography>
  </Box>
);

export default function OrderedBottle({ bottle }) {
  return (
    <Paper
      variant="outlined"
      sx={{ p: 2, mb: 2, borderLeft: 4, borderLeftColor: "primary.main" }}
    >
      <Grid container spacing={2} alignItems="center">
        <Grid size={{ xs: 12, sm: 4 }}>
          <Cell label="Test" value={bottle.Parameter} />
        </Grid>
        <Grid size={{ xs: 12, sm: 4 }}>
          <Cell label="Frequency" value={bottle.SampleFrequency} />
        </Grid>
        <Grid size={{ xs: 12, sm: 4 }}>
          <Cell
            label="Monitor Dates"
            value={`${ToDate(bottle.MonitorStart)} - ${ToDate(bottle.MonitorEnd)}`}
          />
        </Grid>
      </Grid>
    </Paper>
  );
}
